import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  baseIP: string;

  constructor(
    private apiService: ApiService,
  ) { }

  ngOnInit() {
    this.baseIP = this.apiService.getBaseUrl();
    this.baseIP = this.baseIP.substring(7);
    this.baseIP = this.baseIP.substring(0, this.baseIP.indexOf(":"));
  }

}
